// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.63f2407c6.chunk.js";
	if (chunkId === 12) return "static/js/profiler.63f2407c6.chunk.js";
	if (chunkId === 348) return "static/js/348.63f2407c6.chunk.js";
	if (chunkId === 391) return "static/js/391.63f2407c6.chunk.js";
	if (chunkId === 876) return "static/js/876.63f2407c6.chunk.js";
	if (chunkId === 760) return "static/js/760.63f2407c6.chunk.js";
	if (chunkId === 165) return "static/js/165.63f2407c6.chunk.js";
	if (chunkId === 869) return "static/js/869.63f2407c6.chunk.js";
	if (chunkId === 350) return "static/js/350.63f2407c6.chunk.js";
	if (chunkId === 103) return "static/js/103.63f2407c6.chunk.js";
	if (chunkId === 177) return "static/js/177.63f2407c6.chunk.js";
	// return url for filenames based on template
	return undefined;
};